import { APIService } from "@repo/ui/src/services/api-service";
export type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: Role | null;
  team: Team | null;
  hasResetPassword: boolean;
  createdAt: string;
  updatedAt: string;
  redirectUrl: string;
};

interface Role {
  id: string;
  name: string;
}

interface Team {
  id: string;
  name: string;
}

export interface LoginBody {
  email: string;
  password: string;
}
export interface LoginResponse {
  detail: string;
  accessToken: string;
  tokenType: string;
  user: User;
}

export interface SendVerificationMailBody {
  email: string;
}

export interface ForgotPasswordBody {
  email: string;
}

export interface ForgotPasswordResponse {
  detail: string;
}

export interface ResetPasswordWithTokenBody {
  token: string;
  new_password: string;
}

export interface ResetPasswordWithTokenResponse {
  detail: string;
}

export interface ResetPasswordArgs {
  password: string;
  token: string;
}

export interface TokenLoginBody {
  loginToken: string;
}
export interface TokenLoginResponse {
  accessToken: string;
  refreshToken: string;
  role: {
    name: string;
  };
}

console.log(import.meta.env.BASE_URL);

export class AuthenticationService extends APIService {
  static LOGIN_URL = `${this.API_PREFIX_URL}/auth/login`;
  static FORGOT_PASSWORD_URL = `${this.API_PREFIX_URL}/auth/forgot-password`;
  static RESET_PASSWORD_WITH_TOKEN_URL = `${this.API_PREFIX_URL}/auth/reset-password-with-token`;

  static login = ({ email, password }: LoginBody) =>
    this.post<LoginResponse>(AuthenticationService.LOGIN_URL, {
      email,
      password,
    });

  static forgotPassword = ({ email }: ForgotPasswordBody) =>
    this.post<ForgotPasswordResponse>(
      AuthenticationService.FORGOT_PASSWORD_URL,
      {
        email,
      }
    );

  static resetPasswordWithToken = ({
    token,
    new_password,
  }: ResetPasswordWithTokenBody) =>
    this.post<ResetPasswordWithTokenResponse>(
      AuthenticationService.RESET_PASSWORD_WITH_TOKEN_URL,
      {
        token,
        new_password,
      }
    );
}
